// Datei: src/app/state/guards/feature.guard.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, take } from 'rxjs';

import { authFeature } from '../auth/auth.feature';
import { profileFeature } from '../profile/profile.feature';
import { isExpired } from '../models/role.model';

export const featureGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);

  const featureKey = route.data?.['featureKey'] as string | undefined;
  if (!featureKey) return router.parseUrl('/');

  const uid$ = store.select(authFeature.selectUid);
  const status$ = store.select(profileFeature.selectStatus);
  const profile$ = store.select(profileFeature.selectProfile);

  return combineLatest([uid$, status$, profile$]).pipe(
    // Wenn nicht eingeloggt: sofort entscheiden. Wenn eingeloggt: warten bis Profil "ready" oder "error".
    filter(([uid, status]) => !uid || status === 'ready' || status === 'error'),
    take(1),
    map(([uid, status, profile]): boolean | UrlTree => {
      if (!uid) return router.parseUrl('/login');

      if (status === 'error' || !profile) return router.parseUrl('/login');

      if (profile.disabled) return router.parseUrl('/login');
      if (isExpired(profile.expiresAt)) return router.parseUrl('/login');

      const allowed = (profile.enabledFeatures ?? []).includes(featureKey);
      return allowed ? true : router.parseUrl('/login');
    })
  );
};
